<template>
  <div>
    <api-errors :errors="errors" />
    <create-class-overview
      :classDetails="classDetails"
      :organizationType="organizationType"
      :organizationId="organizationId"
      :uploadId="uploadId"
      @update:uploadId="$emit('update:uploadId', $event)"
    />
    <class-create-footer
      :primaryAction="createClass"
      :primaryPreviousAction="editClass"
      :primaryDisabled="primaryDisabled"
      :primaryText="$t('classes.create_class_flow.class_overview.create_and_send_invites')"
      :previousText="$t('common.edit')"
    />
  </div>
</template>

<script>
import InfoRow from "@/components/common/InfoRow";
import Chip from "@/components/common/Chip";
import DisplayStudents from "@/components/modals/classes/DisplayStudents";
import ImportInviteUsers from "@/components/modals/classes/ImportInviteUsers";
import CreateClassOverview from "@/components/classes/create-classes/CreateClassOverview";
import ApiErrors from "@/components/common/ApiErrors";
import ClassCreateFooter from '@/components/classes/create-classes/ClassCreateFooter'
import {
  always,
  isNil,
  path,
  dissoc,
  pathOr,
  length,
  compose,
  propOr,
  objOf,
  map
} from "ramda";
import { mapActions, mapGetters } from "vuex";
import { STUDENT } from "../../../constants/userRoles";
import { f } from 'vue-numeric-input';

export default {
  components: {
    ApiErrors,
    CreateClassOverview,
    ClassCreateFooter,
  },
  props: {
    classDetails: {
      type: Object,
      default: always({ users: [] })
    },
    currentStep: {
      type: Number,
      default: 2
    },
    organizationType: {
      type: String,
      default: ""
    },
    uploadId: {
      default: null
    },
    organizationId: {}
  },
  data() {
    return {
      showStudentsModal: false,
      showImportModal: false,
      errors: {},
      uploadDetails: {},
      primaryLoading: null,
      primaryDisabled: false
    };
  },
  computed: {
  },
  methods: {
    ...mapActions({
      createClassAction: "classes/createClass"
    }),
    openDisplayStudentsModal() {
      this.showStudentsModal = true;
    },
    openImportUsersModal() {
      this.showImportModal = true;
    },
    async createClass() {
      try {
        this.primaryLoading = this.$loading({
          lock: true,
          text: this.$t("common.loading"),
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.7)"
        });
        this.primaryDisabled = true;
        await this.createClassAction(this.classDetails);
        this.primaryLoading.close();
        return this.$emit("next-step", this.currentStep);
      } catch (error) {
        this.errors = error;
      } finally {
        this.primaryLoading.close();
        this.primaryDisabled = false;
      }
    },
    editClass() {
      this.$emit("edit-step");
    },
    ...mapActions("invite", [
      "postSentInviteUploadEmails",
      "patchInviteUploadEmails",
      "getInviteUploadEmails"
    ])
  },
  
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";

::v-deep .base-create-body {
  margin-top: 35px;
}

::v-deep .base-create-footer {
  margin-top: 56px;
}

::v-deep .generic-error-section {
  margin-bottom: 15px;
}
</style>
